export default __webpack_public_path__ + "images/EZ.abec39d.png";